<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Ctest :navsub="11" :options="c_myoption" v-if="isload" :grouplist="grouplist"></Ctest>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'tests',
        mixins: [mixinmember],
        components: {
            Ctest: () => import('@/components/Ctest')
        },
        data() {
            return {
                curnavkv: 28
            };
        },
        computed: {
            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'anycourse': true, 'hasgroup': 1, 'showschool': true, 'showgroup': true };
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        }
    }
</script>
